export default "__VITE_ASSET__By19JT0K__";